import { browserTracingIntegration, extraErrorDataIntegration, init } from '@sentry/vue'
import type { App } from 'vue'

import router from '@/router'

export function createSentry(app: App<Element>) {
    init({
        app,
        dsn: '', // TODO add dsn
        tracePropagationTargets: ['localhost', 'localhost:5173'],
        integrations: [
            browserTracingIntegration({
                router
            }),
            extraErrorDataIntegration()
        ]
    })
}
